import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import Modals from "../../../../components/modal";
import DeleteConfirmation from "../../../../components/delete-confirmation";
import { useDeletePolicy } from "./hooks";
import { useUser } from "../../../../common-hooks/user";

const DeletePolicy = ({ policy }) => {
  const { handleDeletePolicy, isOpenModal, toggleModal, deletePolicyLoading } =
    useDeletePolicy(policy);

  const { isAdmin, isModerator } = useUser();

  if (!isAdmin && !isModerator) {
    return null;
  }

  return (
    <>
      <Tooltip title="Delete" placement="bottom">
        <i
          className={`fa fa-trash icon-btn-action text-danger `}
          onClick={toggleModal}
        ></i>
      </Tooltip>
      {isOpenModal ? (
        <Modals
          isOpenModal
          setIsOpenModal={toggleModal}
          message={
            <DeleteConfirmation
              message="Are you sure you want to delete?"
              handleDelete={handleDeletePolicy}
              isLoading={deletePolicyLoading}
            />
          }
          title="Delete Policy"
        />
      ) : null}
    </>
  );
};

export default DeletePolicy;
